export default "__VITE_ASSET__e1s2OZCG__"